module.exports = __webpack_public_path__ + "media/icons/envelope-591fceec.svg";